function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import { request, useMutation, useQuery } from '@applyboard/ui-utils';
var GET_KYC_RESULTS_PATH = '/api/rpj/v1/kyc/details';
export var JOURNEY_STATUS_VALUES = Object.freeze({
  ALL: 'All',
  NEW: 'New',
  NOTIFIED: 'Notified',
  INITIATED: 'Initiated',
  SUCCEEDED: 'Success',
  FAILED: 'Failure'
});
export var WORKFLOW_STATUS_VALUES = Object.freeze({
  ALL: 'All',
  PROCESSED: 'Processed',
  SESSION_EXPIRED: 'Session Expired'
});
export var KYC_RESULT_VALUES = Object.freeze({
  ALL: 'All',
  PASSED: 'Passed',
  WARNING: 'Warning',
  REJECTED: 'Rejected'
});
export var KycResultKeys = Object.keys(_objectSpread({}, KYC_RESULT_VALUES)).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, key));
}, {});
export var AB_STATUS_VALUES = Object.freeze({
  ALL: 'All',
  NEW: 'New',
  PASSED: 'Approved',
  UNDER_REVIEW: 'Under Review',
  REJECTED: 'Rejected'
});
export var AbStatusKeys = Object.keys(_objectSpread({}, AB_STATUS_VALUES)).reduce(function (acc, key) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, key));
}, {});
var defaultKycStatusResponse = {
  data: [],
  totalCount: 0
};
export function useResetKycDetails() {
  var _useMutation = useMutation(function (_ref) {
      var transactionId = _ref.transactionId;
      var path = "".concat(GET_KYC_RESULTS_PATH, "/").concat(transactionId, "/reset_transaction");
      var response = request(path, {
        method: 'PATCH',
        // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/no-explicit-any -- TODO: Refactor this to use `schema`
        isExpectedResponse: function isExpectedResponse(res) {
          return res;
        },
        changeToCamelCase: true
      });
      return response;
    }),
    mutate = _useMutation.mutate,
    data = _useMutation.data,
    isSuccess = _useMutation.isSuccess,
    isError = _useMutation.isError;
  return {
    kycResetTransaction: mutate,
    kycMutationResponse: data,
    isKycResetTransactionSuccess: isSuccess,
    isKycResetTransactionError: isError
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useKycStatusList(_ref2) {
  var filters = _ref2.filters,
    page = _ref2.page;
  var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var queryParamsMap = {
    'page[size]': page === null || page === void 0 ? void 0 : page.size,
    'page[number]': page === null || page === void 0 ? void 0 : page.number,
    'filter[user_id]': filters === null || filters === void 0 ? void 0 : filters.userId,
    'filter[journey_status]': (filters === null || filters === void 0 ? void 0 : filters.journeyStatus) === 'ALL' ? null : filters.journeyStatus,
    'filter[workflow_status]': (filters === null || filters === void 0 ? void 0 : filters.workflowStatus) === 'ALL' ? null : filters.workflowStatus,
    'filter[kyc_date_from]': filters === null || filters === void 0 ? void 0 : filters.kycCompletionDateFrom,
    'filter[kyc_date_to]': filters === null || filters === void 0 ? void 0 : filters.kycCompletionDateTo,
    'filter[kyc_result]': (filters === null || filters === void 0 ? void 0 : filters.kycResult) === 'ALL' ? null : filters === null || filters === void 0 ? void 0 : filters.kycResult,
    'filter[name_match]': (filters === null || filters === void 0 ? void 0 : filters.nameMatch) === 'ALL' ? null : (filters === null || filters === void 0 ? void 0 : filters.nameMatch) === true ? '1' : '0',
    'filter[ab_status]': (filters === null || filters === void 0 ? void 0 : filters.approvalStatus) === 'ALL' ? null : filters === null || filters === void 0 ? void 0 : filters.approvalStatus,
    'filter[final_decision_date_from]': filters === null || filters === void 0 ? void 0 : filters.finalDecisionDateFrom,
    'filter[final_decision_date_to]': filters === null || filters === void 0 ? void 0 : filters.finalDecisionDateTo
  };
  var filteredQueryParamNames = Object.keys(queryParamsMap).filter(function (key) {
    return queryParamsMap[key] !== undefined && queryParamsMap[key] !== null && queryParamsMap[key] !== '';
  });
  var populatedQueryParamsList = filteredQueryParamNames.map(function (key) {
    return [key, queryParamsMap[key].toString()];
  });
  var queryString = new URLSearchParams(populatedQueryParamsList).toString();
  var queryKey = ['get_kyc_status', queryString];
  var _useQuery = useQuery(queryKey, function () {
      var path = "".concat(GET_KYC_RESULTS_PATH, "/?").concat(queryString);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return request(path, {
        // eslint-disable-next-line no-restricted-syntax,@typescript-eslint/no-explicit-any -- TODO: Refactor this to use `schema`
        isExpectedResponse: function isExpectedResponse(res) {
          return res;
        },
        changeToCamelCase: true
      }).then(function (response) {
        return response;
      });
    }, {
      enabled: enabled
    }),
    isLoading = _useQuery.isLoading,
    isError = _useQuery.isError,
    data = _useQuery.data,
    isSuccess = _useQuery.isSuccess,
    refetch = _useQuery.refetch;
  return {
    refetch: refetch,
    isLoadingGetKycStatusList: isLoading,
    isErrorGetKycStatusList: isError,
    kycStatusList: isSuccess ? data : defaultKycStatusResponse
  };
}